import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AdminLogin from './components/AdminLogin';
import Header from './components/Header';
import Products from './components/Products';
import AddProduct from './components/AddProduct';
import Inventory from './components/Inventory';
import Customers from './components/Customers';
import EmiDashboard from './components/EmiDashboard';
import CustomerDetail from './components/CustomerDetail';
import ProductDetail from './components/ProductDetail';
import EmiDetail from './components/EmiDetail';
import AdvancedBusinessAnalysis from './components/AdvancedBusinessAnalysis';
import NotificationHistory from './components/NotificationHistory';
// import Chatbot from './components/Chatbot'; // Removed - old chatbot
// import ChatbotDashboard from './components/ChatbotDashboard'; // Removed - old chatbot
import CustomerPortal from './components/CustomerPortal';
import HomePage from './components/HomePage';
import AdminDashboard from './components/AdminDashboard';
import RepairCounterApp from './components/RepairCounterApp';
import PawnCounterApp from './components/PawnCounterApp';

function AdminAppContent() {
  const { user, login, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        {/* Standalone mobile repair counter — no admin header */}
        <Route path="/repair-app" element={<RepairCounterApp />} />
        <Route path="/pawn-app/*" element={<PawnCounterApp />} />

        {/* Full admin portal */}
        <Route
          path="/*"
          element={
            user ? (
              <div className="admin-app">
                <Header />
                <div className="container-fluid p-4">
                  <Routes>
                    <Route path="/" element={<AdminDashboard />} />
                    <Route path="/dashboard" element={<AdminDashboard />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/add-product" element={<AddProduct />} />
                    <Route path="/inventory" element={<Inventory />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/customer/:id" element={<CustomerDetail />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    <Route path="/emi" element={<EmiDashboard />} />
                    <Route path="/emi/:id" element={<EmiDetail />} />
                    <Route path="/advanced-business" element={<AdvancedBusinessAnalysis />} />
                    <Route path="/notifications" element={<NotificationHistory />} />
                    <Route path="/customer-portal" element={<CustomerPortal />} />
                    <Route path="/home" element={<HomePage />} />
                    <Route path="*" element={<AdminDashboard />} />
                  </Routes>
                </div>
              </div>
            ) : (
              <AdminLogin onLogin={login} />
            )
          }
        />
      </Routes>
    </Router>
  );
}

function AdminApp() {
  return (
    <AuthProvider>
      <AdminAppContent />
    </AuthProvider>
  );
}

export default AdminApp;
